export const IntlFormatter = (locale, options) => {
  return new Intl.NumberFormat(locale, options)
}